module.exports = __webpack_public_path__ + "static/media/pageheader.1e37b08d.jpeg";